export const AETELUQ = {
  value: "AETELUQ",
  key: "importExport.formats.aeteluq",
};
export const AGECAR = { value: "AGECAR", key: "importExport.formats.agecar" };
export const AGECTR = { value: "AGECTR", key: "importExport.formats.agectr" };
export const AGECRO_CONTINUING_EDUCATION = { value: "AGECRO_CONTINUING_EDUCATION", key: "importExport.formats.agecro.continuingEducation" };
export const AGECRO_REGULAR_EDUCATION = { value: "AGECRO_REGULAR_EDUCATION", key: "importExport.formats.agecro.regularEducation" };
export const AGECRO_ONLINE_EDUCATION = { value: "AGECRO_ONLINE_EDUCATION", key: "importExport.formats.agecro.onlineEducation" };
export const AGEUQTR = {
  value: "AGEUQTR",
  key: "importExport.formats.ageuqtr",
};
export const FEUS = { value: "FEUS", key: "importExport.formats.feus" };
export const CORPORATE = {
  value: "CORPORATE",
  key: "importExport.formats.corporate",
};

export default [AETELUQ, AGECAR, AGECTR, AGEUQTR, CORPORATE, FEUS, AGECRO_CONTINUING_EDUCATION, AGECRO_ONLINE_EDUCATION, AGECRO_REGULAR_EDUCATION];



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/importMembers/enums/importMemberFormats.js